import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SalesTransaction, CreateSalesTransactionDto } from '../models/sales-transaction.model';
import { apiBase } from './api-config';

@Injectable({ providedIn: 'root' })
export class SalesTransactionService {
  private http = inject(HttpClient);
  private base = `${apiBase}/sales`;

  getAll(customerId?: number): Observable<SalesTransaction[]> {
    const params = customerId ? new HttpParams().set('customerId', customerId) : undefined;
    return this.http.get<SalesTransaction[]>(this.base, { params });
  }

  getById(id: number): Observable<SalesTransaction> {
    return this.http.get<SalesTransaction>(`${this.base}/${id}`);
  }

  create(dto: CreateSalesTransactionDto): Observable<SalesTransaction> {
    return this.http.post<SalesTransaction>(this.base, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }
}
